<div class="dali102and207-container">
  <!-- DIMMING CURVE -->
  <div class="row mt-3">
    <div class="col-3">
      <div class="signifyBookmd bold-text" id="DALI102and207-dimmingcurve-text">
        Dimming curve
      </div>
    </div>
  </div>
  <div class="aligned-sections-grid">
    <!-- radios -->
    <div class="grid-labels">
      <div class="dimming-curve-options">
        <label class="radio-label" aria-hidden="true">
          <input type="radio" name="dimmingCurve" value="Linear" [(ngModel)]="dimmingCurveType"
            (change)="onDimmingCurveChange()" id="DALI102and207-linear-radio" class="dimming-radio" />
            <span class="signifyBookmd radio-text" id="DALI102and207-linear-text">Linear</span>
          </label>
          <label class="radio-label" aria-hidden="true">
            <input type="radio" name="dimmingCurve" value="Logarithmic" [(ngModel)]="dimmingCurveType"
              (change)="onDimmingCurveChange()" id="DALI102and207-logarithmic-radio" class="dimming-radio" />
              <span class="signifyBookmd radio-text" id="DALI102and207-logarithmic-text">
                Logarithmic
              </span>
            </label>
          </div>
        </div>
        <!-- POWER LEVELS TITLE -->
        <div class="grid-label mt-4">
          <div class="signifyBookmd bold-text" id="DALI102and207-powerlevels-text">
            Power levels
          </div>
        </div>
        <!-- Min level and Max level -->
        <div class="grid-content mt-3">
          <div class="power-levels-grid">
            <div class="row-item two-column-layout">
              <div class="column-item">
                <span class="signifyBookmd" id="DALI102and207-minlevel-text">Min level</span>
                <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                  (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="minLevel"
                  (input)="onMinLevelInput($event.target.value)" [ngClass]="{'myStyle': minLevelError === true}"
                  id="DALI102and207-minlevel-input" />
                  <p id="DALI102and207-minlevel-percentage" class="signifyBookmd mb-0 ml-2">(&#8776;@if (minLevelPercentage !== null) {{{minLevelPercentage}}} %)</p>
                </div>
                <div class="column-item">
                  <span class="signifyBookmd" id="DALI102and207-maxlevel-text">Max level</span>
                  <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                    (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="maxLevel"
                    (input)="onMaxLevelInput($event.target.value)" [ngClass]="{'myStyle': maxLevelError === true}"
                    id="DALI102and207-maxlevel-input" />
                    <p id="DALI102and207-maxlevel-percentage" class="signifyBookmd mb-0 ml-2">(&#8776;@if (maxLevelPercentage !== null) {{{maxLevelPercentage}}} %)</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Power on level -->
            <div class="grid-content mt-3">
              <div class="power-levels-grid">
                <div class="row-item align-with-max">
                  <span class="signifyBookmd" id="DALI102and207-poweron-text">
                    Power on level
                  </span>
                  <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                    (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="powerOnLevel"
                    (input)="onPowerOnLevelInput($event.target.value, $event)" [disabled]="useLastStoredLevel"
                    [ngClass]="{'myStyle': powerOnLevelError === true, 'isResetDisabled custom-inputbox-disabled': useLastStoredLevel}"
                    id="DALI102and207-poweron-input" />
                    <p id="DALI102and207-poweron-percentage" class="signifyBookmd mb-0 ml-2">(&#8776;@if (powerOnLevelPercentage !== null) {{{powerOnLevelPercentage}}} %)</p>
                    <input type="checkbox" class="p-checkbox ml-2" [(ngModel)]="useLastStoredLevel"
                      (change)="onUseLastStoredLevelChange()" id="DALI102and207-uselast-checkbox" />
                      <span class="signifyBookmd" id="DALI102and207-uselast-text">
                        Use last stored level
                      </span>
                    </div>
                  </div>
                </div>
                <!-- System failure -->
                <div class="grid-content mt-3">
                  <div class="power-levels-grid">
                    <div class="row-item align-with-max">
                      <span class="signifyBookmd" id="DALI102and207-systemfailure-text">
                        System failure level
                      </span>
                      <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                        (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="systemFailureLevel"
                        (input)="onSystemFailureLevelInput($event.target.value, $event)" [disabled]="dontChangeExistingLevel"
                        [ngClass]="{'myStyle': systemFailureLevelError === true, 'isResetDisabled custom-inputbox-disabled': dontChangeExistingLevel}"
                        id="DALI102and207-systemfailure-input" />
                        <p id="DALI102and207-systemfailure-percentage" class="signifyBookmd mb-0 ml-2">(&#8776;@if (systemFailureLevelPercentage !== null) {{{systemFailureLevelPercentage}}} %)</p>
                        <input type="checkbox" class="p-checkbox ml-2" [(ngModel)]="dontChangeExistingLevel"
                          (change)="onDontChangeExistingLevelChange()" id="DALI102and207-dontchange-checkbox" />
                          <span class="signifyBookmd" id="DALI102and207-dontchange-text">
                            Don't change existing level
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- FADE -->
                    <div class="grid-label mt-4">
                      <div class="signifyBookmd bold-text" id="DALI102and207-fade-text">Fade</div>
                    </div>
                    <!-- Fade Rate -->
                    <div class="grid-content mt-3 fade-grid">
                      <div class="row-item">
                        <div class="label-column">
                          <span class="signifyBookmd" id="DALI102and207-faderate-text">
                            Fade rate
                          </span>
                        </div>
                        <div class="input-column">
                          <select class="time-select-extended" [(ngModel)]="fadeRate" (ngModelChange)="onFadeRateChange()"
                            id="DALI102and207-faderate-input">
                            @for (rate of fadeRateOptions; track rate) {
                              <option [ngValue]="rate">{{rate}}</option>
                            }
                          </select>
                          <span class="signifyBookmd unit-label" id="DALI102and207-faderate-unit">steps/s</span>
                        </div>
                      </div>
                    </div>
                    <!-- Fade Time, Fast Fade Time, Extended Fade Time -->
                    <div class="grid-content mt-3 fade-grid">
                      <div class="row-item">
                        <div class="label-column">
                          <label class="radio-label" aria-hidden="true">
                            <input type="radio" name="fadeType" id="DALI102and207-fadetime-radio" class="dimming-radio"
                              [(ngModel)]="selectedFadeType" value="fadeTime" (change)="onFadeTimeRadioChange()" />
                              <span class="signifyBookmd radio-text" id="DALI102and207-fadetime-text">
                                Fade time
                              </span>
                            </label>
                          </div>
                          <div class="input-column">
                            <select class="time-select-extended" [(ngModel)]="fadeTime" (ngModelChange)="onFadeTimeChange()"
                              id="DALI102and207-fadetime-input">
                              @for (time of fadeTimeOptions; track time) {
                                <option [ngValue]="time">{{time}}</option>
                              }
                            </select>
                            <span class="signifyBookmd unit-label unit-label-2" id="DALI102and207-fadetime-unit">s</span>
                          </div>
                        </div>
                        <div class="row-item">
                          <div class="label-column">
                            <label class="radio-label" aria-hidden="true">
                              <input type="radio" name="fadeType" id="DALI102and207-fastfade-radio" class="dimming-radio"
                                [(ngModel)]="selectedFadeType" value="fastFadeTime" (change)="onFastFadeTimeRadioChange()" />
                                <span class="signifyBookmd radio-text" id="DALI102and207-fastfade-text">
                                  Fast fade time
                                </span>
                              </label>
                            </div>
                            <div class="input-column">
                              <select class="time-select-extended" [(ngModel)]="fastFadeTime" (ngModelChange)="onFastFadeTimeChange()"
                                id="DALI102and207-fastfade-input">
                                @for (time of fastFadeTimeOptions; track time) {
                                  <option [ngValue]="time">{{time}}</option>
                                }
                              </select>
                              <span class="signifyBookmd unit-label unit-label-3" id="DALI102and207-fastfade-unit">ms</span>
                            </div>
                          </div>
                          <div class="row-item">
                            <div class="label-column">
                              <label class="radio-label" aria-hidden="true">
                                <input type="radio" name="fadeType" id="DALI102and207-extendedfade-radio"
                                  [(ngModel)]="selectedFadeType" value="extendedFadeTime" (change)="onExtendedFadeTimeRadioChange()" />
                                  <span class="signifyBookmd radio-text" id="DALI102and207-extendedfade-text">
                                    Extended fade time
                                  </span>
                                </label>
                              </div>
                              <div class="input-column">
                                <select class="time-select-extended" [(ngModel)]="extendedFadeTime" (ngModelChange)="onExtendedFadeTimeChange()"
                                  id="DALI102and207-extendedfade-input">
                                  @for (time of extendedFadeTimeOptions; track time) {
                                    <option [ngValue]="time">{{time}}</option>
                                  }
                                </select>
                                <span class="signifyBookmd unit-label unit-label-2" id="DALI102and207-extendedfade-unit">s</span>
                              </div>
                            </div>
                          </div>

                          <!-- OPERATING MODE -->
                          <div class="grid-label mt-4">
                            <div class="signifyBookmd bold-text" id="DALI102and207-operatingmode-text">
                              Operating mode
                              <img class="info" (click)="openInfo($event)" (keydown.enter)="openInfo($event)" (keydown.space)="openInfo($event); $event.preventDefault()" src="{{ pathVal }}info.png" placement="right" [autoClose]="'outside'" [ngbTooltip]="operatingModeConfig" triggers="click:blur" tooltipClass="dali-info-tooltip" #opMode="ngbTooltip" (click)="opMode.open()" alt="Information" />
                              <ng-template #operatingModeConfig>
                                <div class="row app-area-container">
                                  <div class="col-9 title-tooltip">Operating Mode</div>
                                  <div class="col-3 tooltip-image">
                                    <img src="{{ pathVal }}close.png" (click)="[opMode.close(), openInfo($event)]" (keydown.enter)="[opMode.close(), openInfo($event)]" (keydown.space)="[opMode.close(), openInfo($event)]; $event.preventDefault()" alt="Close" />
                                  </div>
                                  <div class="col-12 tooltip-description px-0">
                                    Operating mode can either be 0 or between 128 - 255
                                  </div>
                                </div>
                              </ng-template>
                            </div>
                          </div>
                          <div class="grid-content mt-3 fade-grid">
                            <div class="row-item">
                              <div class="label-column">
                                <span class="signifyBookmd" id="DALI102and207-operatingmode2-text">
                                  Operating mode
                                </span>
                              </div>
                              <div class="input-column">
                                <select class="time-select-extended" [(ngModel)]="operatingMode" (ngModelChange)="onOperatingModeChange()"
                                  id="DALI102and207-operatingmode-input">
                                  @for (mode of operatingModeOptions; track mode) {
                                    <option [ngValue]="mode">{{mode}}</option>
                                  }
                                </select>
                              </div>
                            </div>
                          </div>

                          <!-- SCENES -->
                          <div class="grid-label mt-4">
                            <div class="signifyBookmd bold-text" id="DALI102and207-scenes-text">
                              Scenes
                            </div>
                          </div>
                          <div class="grid-content mt-3">
                            <div class="scenes-grid">
                              <!-- Column 1: Scenes 0-3 -->
                              <div class="scene-column">
                                <div class="scene-item">
                                  <span class="scene-label signifyBookmd" id="DALI102and207-scene-0-text">Scene 0</span>
                                  <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                    (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[0]"
                                    (input)="onSceneInput(0, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[0] === true}"
                                    id="DALI102and207-scene-0-input" />
                                  </div>
                                  <div class="scene-item">
                                    <span class="scene-label signifyBookmd" id="DALI102and207-scene-1-text">Scene 1</span>
                                    <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                      (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[1]"
                                      (input)="onSceneInput(1, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[1] === true}"
                                      id="DALI102and207-scene-1-input" />
                                    </div>
                                    <div class="scene-item">
                                      <span class="scene-label signifyBookmd" id="DALI102and207-scene-2-text">Scene 2</span>
                                      <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                        (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[2]"
                                        (input)="onSceneInput(2, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[2] === true}"
                                        id="DALI102and207-scene-2-input" />
                                      </div>
                                      <div class="scene-item">
                                        <span class="scene-label signifyBookmd" id="DALI102and207-scene-3-text">Scene 3</span>
                                        <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                          (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[3]"
                                          (input)="onSceneInput(3, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[3] === true}"
                                          id="DALI102and207-scene-3-input" />
                                        </div>
                                      </div>
                                      <!-- Column 2: Scenes 4-7 -->
                                      <div class="scene-column">
                                        <div class="scene-item">
                                          <span class="scene-label signifyBookmd" id="DALI102and207-scene-4-text">Scene 4</span>
                                          <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                            (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[4]"
                                            (input)="onSceneInput(4, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[4] === true}"
                                            id="DALI102and207-scene-4-input" />
                                          </div>
                                          <div class="scene-item">
                                            <span class="scene-label signifyBookmd" id="DALI102and207-scene-5-text">Scene 5</span>
                                            <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                              (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[5]"
                                              (input)="onSceneInput(5, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[5] === true}"
                                              id="DALI102and207-scene-5-input" />
                                            </div>
                                            <div class="scene-item">
                                              <span class="scene-label signifyBookmd" id="DALI102and207-scene-6-text">Scene 6</span>
                                              <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                                (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[6]"
                                                (input)="onSceneInput(6, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[6] === true}"
                                                id="DALI102and207-scene-6-input" />
                                              </div>
                                              <div class="scene-item">
                                                <span class="scene-label signifyBookmd" id="DALI102and207-scene-7-text">Scene 7</span>
                                                <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                                  (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[7]"
                                                  (input)="onSceneInput(7, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[7] === true}"
                                                  id="DALI102and207-scene-7-input" />
                                                </div>
                                              </div>
                                              <!-- Column 3: Scenes 8-11 -->
                                              <div class="scene-column">
                                                <div class="scene-item">
                                                  <span class="scene-label signifyBookmd" id="DALI102and207-scene-8-text">Scene 8</span>
                                                  <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                                    (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[8]"
                                                    (input)="onSceneInput(8, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[8] === true}"
                                                    id="DALI102and207-scene-8-input" />
                                                  </div>
                                                  <div class="scene-item">
                                                    <span class="scene-label signifyBookmd" id="DALI102and207-scene-9-text">Scene 9</span>
                                                    <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                                      (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[9]"
                                                      (input)="onSceneInput(9, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[9] === true}"
                                                      id="DALI102and207-scene-9-input" />
                                                    </div>
                                                    <div class="scene-item">
                                                      <span class="scene-label signifyBookmd" id="DALI102and207-scene-10-text">Scene 10</span>
                                                      <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                                        (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[10]"
                                                        (input)="onSceneInput(10, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[10] === true}"
                                                        id="DALI102and207-scene-10-input" />
                                                      </div>
                                                      <div class="scene-item">
                                                        <span class="scene-label signifyBookmd" id="DALI102and207-scene-11-text">Scene 11</span>
                                                        <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                                          (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[11]"
                                                          (input)="onSceneInput(11, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[11] === true}"
                                                          id="DALI102and207-scene-11-input" />
                                                        </div>
                                                      </div>
                                                      <!-- Column 4: Scenes 12-15 -->
                                                      <div class="scene-column">
                                                        <div class="scene-item">
                                                          <span class="scene-label signifyBookmd" id="DALI102and207-scene-12-text">Scene 12</span>
                                                          <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                                            (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[12]"
                                                            (input)="onSceneInput(12, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[12] === true}"
                                                            id="DALI102and207-scene-12-input" />
                                                          </div>
                                                          <div class="scene-item">
                                                            <span class="scene-label signifyBookmd" id="DALI102and207-scene-13-text">Scene 13</span>
                                                            <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                                              (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[13]"
                                                              (input)="onSceneInput(13, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[13] === true}"
                                                              id="DALI102and207-scene-13-input" />
                                                            </div>
                                                            <div class="scene-item">
                                                              <span class="scene-label signifyBookmd" id="DALI102and207-scene-14-text">Scene 14</span>
                                                              <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                                                (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[14]"
                                                                (input)="onSceneInput(14, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[14] === true}"
                                                                id="DALI102and207-scene-14-input" />
                                                              </div>
                                                              <div class="scene-item">
                                                                <span class="scene-label signifyBookmd" id="DALI102and207-scene-15-text">Scene 15</span>
                                                                <input type="number" class="input-text form-control signifyBookmd textbox-standard"
                                                                  (keypress)="numberOnly($event)" (paste)="onPaste($event)" [value]="scenes[15]"
                                                                  (input)="onSceneInput(15, $event.target.value)" [ngClass]="{'myStyle': sceneErrors[15] === true}"
                                                                  id="DALI102and207-scene-15-input" />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
